import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 所有権移転区分*/
enum OwnershipRightsTrfType {
  ownershipRightsTrf = '1',
  ownershipRightsNonTrf = '2',
}

const nameConfig = {
  ownershipRightsTrf: new Map([[Locale.ja, '所有権移転']]),
  ownershipRightsNonTrf: new Map([[Locale.ja, '所有権移転外']]),
};

const toEnum = rawValueToEnum(OwnershipRightsTrfType, OwnershipRightsTrfType.ownershipRightsTrf);
const toDisplay = enumToName(OwnershipRightsTrfType, nameConfig);
const toDisplayWithPrefix = enumToName(OwnershipRightsTrfType, nameConfig, { prefix: true });

export const ownershipRightsTrfType = {
  enum: OwnershipRightsTrfType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { OwnershipRightsTrfType };
